export const numberFormatter = (num) => {
  return new Intl.NumberFormat('ja-JP').format(num);
};